import urlContext, { Contexts } from '../urlContext/urlContext';

// The parallel v2 stack uses the -v2 Cloud Function (which reads/writes the
// cloned default-v2 database). USE_V2_BACKEND is injected at build time by
// webpack DefinePlugin (empty => the live v1 backend). Gen 2 functions still
// resolve via the classic cloudfunctions.net/<name> alias, so only the function
// name changes.
const API_FUNCTION =
  process.env.USE_V2_BACKEND === 'true'
    ? 'pharma-graphql-ws-v2'
    : 'pharma-graphql-ws';

const CONTEXT_URL = {
  [Contexts.LOCAL]: 'http://localhost:9031',
  [Contexts.DEV]:
    `https://us-central1-ut-uid-pharma-dev.cloudfunctions.net/${API_FUNCTION}`,
  [Contexts.AT]:
    `https://us-central1-ut-uid-pharma-at.cloudfunctions.net/${API_FUNCTION}`,
  [Contexts.PROD]:
    `https://us-central1-ut-uid-pharma-prod.cloudfunctions.net/${API_FUNCTION}`,
};
export default CONTEXT_URL[urlContext()];
